import { rgba, rtlNoFlip } from '../styles/utilities';
export var TooltipOverrides = function (theme) {
    var _a, _b, _c, _d;
    var tooltipBackgroundColor = theme.palette.type === 'light' ? theme.palette.background.default : theme.palette.background.b3;
    var tooltipBorderColor = theme.palette.type === 'light' ? theme.palette.border.main : theme.palette.background.b4;
    var tooltipOffset = '16px';
    var arrowSize = '14px';
    var arrowBorderSize = '17px';
    var arrowOffset = '-8px';
    return {
        MuiTooltip: {
            popper: {
                opacity: undefined,
            },
            tooltip: {
                position: 'relative',
                maxWidth: '300px',
                padding: '7px 12px',
                fontSize: theme.typography.fontSizeDefault,
                backgroundColor: tooltipBackgroundColor,
                border: '1px solid',
                borderColor: tooltipBorderColor,
                boxShadow: theme.palette.type === 'light'
                    ? "".concat(rgba(theme.palette.background.b9, 0.075), " 0px 0px 0px 4px")
                    : undefined,
                color: theme.palette.text.primary,
            },
            popperArrow: {
                '&[x-placement*="top"] $arrow': {
                    width: undefined,
                    height: undefined,
                    marginBottom: arrowOffset,
                    transform: rtlNoFlip('rotate(45deg)'),
                    '&::before': {
                        borderColor: undefined,
                        borderWidth: undefined,
                    },
                },
                '&[x-placement*="bottom"] $arrow': {
                    width: undefined,
                    height: undefined,
                    marginTop: arrowOffset,
                    transform: rtlNoFlip('rotate(-135deg)'),
                    '&::before': {
                        borderColor: undefined,
                        borderWidth: undefined,
                    },
                },
                '&[x-placement*="left"] $arrow': {
                    width: undefined,
                    height: undefined,
                    marginTop: '10px',
                    marginBottom: '11px',
                    marginRight: arrowOffset,
                    transform: rtlNoFlip('rotate(-45deg)'),
                    '&::before': {
                        borderColor: undefined,
                        borderWidth: undefined,
                    },
                },
                '&[x-placement*="right"] $arrow': {
                    width: undefined,
                    height: undefined,
                    marginTop: '10px',
                    marginBottom: '11px',
                    marginLeft: arrowOffset,
                    transform: rtlNoFlip('rotate(135deg)'),
                    '&::before': {
                        borderColor: undefined,
                        borderWidth: undefined,
                    },
                },
            },
            arrow: {
                color: undefined,
                overflow: undefined,
                width: arrowSize,
                height: arrowSize,
                '&::before, &::after': {
                    content: '""',
                    position: 'absolute',
                },
                '&::before': {
                    borderStyle: undefined,
                    backgroundColor: undefined,
                    transform: undefined,
                    width: arrowBorderSize,
                    height: arrowBorderSize,
                    background: theme.palette.type === 'light'
                        ? "linear-gradient(135deg,\n              ".concat(rgba(theme.palette.background.b9, 0), " 0%,\n              ").concat(rgba(theme.palette.background.b9, 0), " 58%,\n              ").concat(rgba(theme.palette.background.b9, 0.075), " 58%,\n              ").concat(rgba(theme.palette.background.b9, 0.075), " 100%)")
                        : undefined,
                },
                '&::after': {
                    width: '100%',
                    height: '100%',
                    background: "linear-gradient(135deg,\n            ".concat(rgba(tooltipBackgroundColor, 0), " 0%,\n            ").concat(rgba(tooltipBackgroundColor, 0), " 48%,\n            ").concat(rgba(tooltipBackgroundColor, 1), " 48%,\n            ").concat(rgba(tooltipBackgroundColor, 1), " 100%)"),
                    backgroundColor: rgba(tooltipBackgroundColor, 0.01), // needed for high contrast mode
                    borderRight: rtlNoFlip("1px solid ".concat(tooltipBorderColor)),
                    borderBottom: rtlNoFlip("1px solid ".concat(tooltipBorderColor)),
                },
            },
            tooltipPlacementLeft: (_a = {
                    margin: "0 ".concat(tooltipOffset)
                },
                _a[theme.breakpoints.up('sm')] = {
                    margin: "0 ".concat(tooltipOffset),
                },
                _a),
            tooltipPlacementRight: (_b = {
                    margin: "0 ".concat(tooltipOffset)
                },
                _b[theme.breakpoints.up('sm')] = {
                    margin: "0 ".concat(tooltipOffset),
                },
                _b),
            tooltipPlacementTop: (_c = {
                    margin: "".concat(tooltipOffset, " 0")
                },
                _c[theme.breakpoints.up('sm')] = {
                    margin: "".concat(tooltipOffset, " 0"),
                },
                _c),
            tooltipPlacementBottom: (_d = {
                    margin: "".concat(tooltipOffset, " 0")
                },
                _d[theme.breakpoints.up('sm')] = {
                    margin: "".concat(tooltipOffset, " 0"),
                },
                _d),
        },
    };
};
//# sourceMappingURL=Tooltip.overrides.js.map